import apiV2 from '.'

export const employeesApi = apiV2.injectEndpoints({
  endpoints: builder => ({
    removeEmployeeV2: builder.mutation({
      query: ({ domainId, companyId, userId }) => ({
        url: `/domains/${domainId}/companies/${companyId}/users/${userId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['EMPLOYEES'],
    }),
  }),
})

export const { useRemoveEmployeeV2Mutation } = employeesApi
